import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function OpenclawUseCases() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5581">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-12 lg:p-16 relative overflow-hidden" data-id="element-5582">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-5583">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-5584">
            An AI agent for{' '}
            <span className="text-blue-600" data-id="element-5585">every sales team</span>
          </h2>
          <p className="text-lg text-slate-500 leading-relaxed" data-id="element-5586">
            See how B2B sales teams use Openclaw for sales to automate their
            top-of-funnel prospecting and outreach.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-5587">
          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-5588">
            <div data-id="element-5589">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-5590">
                SDRs & BDRs
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-5591">
                SDRs use the agent to automate list building and email drafting,
                freeing up hours of manual research time every day.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-5592">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-5593" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-5594">
                The agent does the heavy lifting of finding and scoring leads. I
                just review the drafts and hit send.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-5595">
                — James T., SDR
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-5596">
            <div data-id="element-5597">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-5598">
                Founders & Solo Sales
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-5599">
                Founders use the agent as their first SDR hire, letting it
                handle top-of-funnel while they focus on closing deals.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-5600">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-5601" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-5602">
                It's literally like having a junior researcher on staff who
                works 24/7 and never complains.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-5603">
                — Sarah M., Startup Founder
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-5604">
            <div data-id="element-5605">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-5606">
                Marketing Agencies
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-5607">
                Agencies use the agent to quickly source highly targeted lists
                of local businesses for their clients' campaigns.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-5608">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-5609" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-5610">
                We used to spend days building lists. Now we just describe what
                we need and get it in minutes.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-5611">
                — David L., Agency Director
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}